import React from 'react';
import _merge from 'lodash/merge';

import { getContext } from 'common';
import Styled from './styles';

export interface ProgressIndicatorTextProps extends React.ComponentPropsWithRef<'div'> {
  /** to show units or progress */
  children: string;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** ProgressIndicatorText component renders the text of LinearProgressIndicatorDeterminate component.
 * All props other than `children` will be provided to the root DOM element.
 * */
const ProgressIndicatorText = React.forwardRef<HTMLElement, ProgressIndicatorTextProps>((props: ProgressIndicatorTextProps, ref) => getContext(({ theme }) => {
  const {
    children,
    theme: themeProp,
    ...otherProps
  } = props;

  const resolvedTheme = _merge({}, theme ? theme.LINEAR_PROGRESS_DETERMINATE : {}, themeProp);

  return (
    <Styled.ProgressBarText
      ref={ref}
      $theme={resolvedTheme}
      {...otherProps}
    >
      {children}
    </Styled.ProgressBarText>
  );
}));

ProgressIndicatorText.defaultProps = {
  theme: {}
};

ProgressIndicatorText.displayName = 'ProgressIndicatorText';

export default ProgressIndicatorText;
